module.exports = __webpack_public_path__ + "img/PC_guide.b7966cc3.jpg";